import React, { Component } from "react";
import { times } from "ramda";
import "./style.css";

class YearTicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duration: 1000,
      current: 2000,
    };

    this.setDuration = this.setDuration.bind(this);
  }

  setDuration(next, prev = 2000, msPerNumber = 100) {
    this.setState({ prev });
  }

  createLoop(perFrame = 100, backwards = false) {
    this.loop = setInterval(() => {
      const offset = backwards ? -1 : 1;

      if (this.state.current + 1 * offset === this.props.year) {
        this.clearLoop();
      }

      this.setState({
        current: Math.round(this.state.current + 1 * offset),
      });
    }, perFrame);
  }

  clearLoop() {
    if (this.loop) {
      clearInterval(this.loop);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.year !== this.props.year) {
      this.clearLoop();
      const diff = nextProps.year - this.props.year;
      const duration = Math.abs(diff) * 100;
      const perFrame = duration / Math.abs(diff);
      this.createLoop(perFrame, diff < 0);
    }
  }

  render() {
    const { year } = this.props;
    const { current, duration } = this.state;
    return (
      <div className="years">
        {times(
          n => (
            <span className="year" key={n}>
              {2015 + n}
            </span>
          ),
          1
        )}
      </div>
    );
  }
}

export default YearTicker;



// WEBPACK FOOTER //
// ./src/components/yearTicker/index.js